import React, { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import { joinClasses } from '../../../../Utils/className.util';
import ErrorMessage from '../ErrorMessage';
import Input, { InputProps } from '../Input';
import TopFieldContent from '../TopFieldContent';
//@ts-ignore
import styles from './NumberField.module.scss';
import { isString, isNumber } from 'lodash';
import CharactersCount from '../CharactersCount/CharactersCount';

const MAX_DECIMAL_PLACES_REGEX = /^\d*([.,]?)\d*$/;

interface InputFieldProps extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	useWrapper?: boolean;
	disabled?: boolean;
	charactersLimit?: number;
	showCharCounter?: boolean;
}

const NumberField = ({
	name,
	label,
	isRequired,
	className,
	useWrapper = true,
	disabled,
	charactersLimit,
	showCharCounter = true,
	...inputProps
}: InputFieldProps) => {
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	useEffect(() => {
		if (!isString(field.value) && !isNumber(field.value)) {
			field.onChange('');
		}
	}, [field.value]);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		// @ts-ignore
		const value = event.target.value.replace(',', '.'); // Nahrazení čárky tečkou
		const matches = value.match(MAX_DECIMAL_PLACES_REGEX);
		if (matches) {
			field.onChange(value);
		}
	};

	return (
		<div
			className={joinClasses([
				className,
				useWrapper ? styles.wrapper : undefined,
			])}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<Input
				hasError={Boolean(error?.message)}
				{...inputProps}
				{...field}
				type='text'
				pattern='^\d*([.,]?)\d*$'
				disabled={disabled}
				onChange={handleChange}
				onFocus={event =>
					// @ts-ignore
					event.target.addEventListener('wheel', (event: React.FocusEvent) => {
						event.preventDefault();
					})
				}
				maxLength={charactersLimit}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
			{charactersLimit && showCharCounter && (
				<CharactersCount limit={charactersLimit} value={field.value} />
			)}
		</div>
	);
};

export default NumberField;
